import React from "react";
import { History, ShieldCheck } from "lucide-react";

import { chatText } from "../messages";

export function ChatHeader({ onShowHistory }) {
  return (
    <header className="flex items-center justify-between gap-3 bg-[#042416] px-4 py-3 pr-16 text-white shadow-sm">
      <div className="flex min-w-0 items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#C0F6B7] text-[#042416]">
          <ShieldCheck size={20} strokeWidth={1.8} />
        </div>
        <div className="min-w-0 text-left">
          <h1 className="truncate font-serif text-[16px] font-semibold text-[#C0F6B7]">BluPay</h1>
          <p className="text-[11px] text-white/65">{chatText("chat.header.subtitle")}</p>
        </div>
      </div>
      {onShowHistory && (
        <button
          type="button"
          onClick={onShowHistory}
          aria-label={chatText("chat.header.history")}
          className="rounded-full p-2 text-white/70 hover:bg-white/10"
        >
          <History size={19} />
        </button>
      )}
    </header>
  );
}
